import { Routes, Route } from "react-router-dom";

import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { AppShell } from "@/components/layout/AppShell";
import { HomePage } from "@/pages/HomePage";
import { ResumePurchasePage } from "@/pages/ResumePurchasePage";
import { LoginPage } from "@/pages/LoginPage";
import { RegisterPage } from "@/pages/RegisterPage";
import { ForgotPasswordPage } from "@/pages/ForgotPasswordPage";
import { ResetPasswordPage } from "@/pages/ResetPasswordPage";
import { VerifyEmailPage } from "@/pages/VerifyEmailPage";
import { PurchaseFlowPage } from "@/pages/PurchaseFlowPage";
import { DashboardPage } from "@/pages/DashboardPage";
import { DomainsPage } from "@/pages/DomainsPage";
import { DomainDetailPage } from "@/pages/DomainDetailPage";
import { PlanDetailPage } from "@/pages/PlanDetailPage";
import { PlansPage } from "@/pages/PlansPage";
import { OnboardingPage } from "@/pages/OnboardingPage";
import { SettingsPage } from "@/pages/SettingsPage";
import { BillingPage } from "@/pages/BillingPage";
import { AddOnsPage } from "@/pages/AddOnsPage";
import { CartPage } from "@/pages/CartPage";
import { CheckoutPage } from "@/pages/CheckoutPage";
import { CheckoutSuccessPage } from "@/pages/CheckoutSuccessPage";
import { CheckoutCancelPage } from "@/pages/CheckoutCancelPage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { AdminLayout } from "@/components/layout/AdminLayout";
import { AdminOverviewPage } from "@/pages/admin/AdminOverviewPage";
import { AdminCustomersPage } from "@/pages/admin/AdminCustomersPage";
import { AdminCustomerDetailPage } from "@/pages/admin/AdminCustomerDetailPage";
import { AdminLeadsPage } from "@/pages/admin/AdminLeadsPage";
import { AdminWebhooksPage } from "@/pages/admin/AdminWebhooksPage";
import { AdminPlansPage } from "@/pages/admin/AdminPlansPage";
import { AdminAddOnsPage } from "@/pages/admin/AdminAddOnsPage";
import { AdminSyncPage } from "@/pages/admin/AdminSyncPage";
import { AdminEmailPage } from "@/pages/admin/AdminEmailPage";
import { AdminReportsPage } from "@/pages/admin/AdminReportsPage";
import { AdminSupportPage } from "@/pages/admin/AdminSupportPage";
import { AdminProvisioningPage } from "@/pages/admin/AdminProvisioningPage";

export default function App() {
  return (
    <Routes>
      {/* Public marketing + auth routes */}
      <Route path="/" element={<HomePage />} />
      <Route path="/plans" element={<PlansPage />} />
      {/* Plan selection + domain picking are public; login is enforced only
          at checkout (the flow stashes the selection and resumes after login). */}
      <Route path="/buy/:slug" element={<PurchaseFlowPage />} />
      <Route
        path="/buy/resume"
        element={
          <ProtectedRoute>
            <ResumePurchasePage />
          </ProtectedRoute>
        }
      />
      <Route path="/onboarding" element={<OnboardingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />

      {/* Protected app shell */}
      <Route
        element={
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/plans/:id" element={<PlanDetailPage />} />
        <Route path="/domains" element={<DomainsPage />} />
        <Route path="/domains/:id" element={<DomainDetailPage />} />
        <Route path="/add-ons" element={<AddOnsPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
        <Route path="/checkout/cancel" element={<CheckoutCancelPage />} />
        <Route path="/billing" element={<BillingPage />} />
        <Route path="/settings" element={<SettingsPage />} />

        {/* Admin section — AdminLayout wraps everything with AdminGuard */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index            element={<AdminOverviewPage />} />
          <Route path="provisioning" element={<AdminProvisioningPage />} />
          <Route path="customers" element={<AdminCustomersPage />} />
          <Route path="customers/:id" element={<AdminCustomerDetailPage />} />
          <Route path="leads"     element={<AdminLeadsPage />} />
          <Route path="webhooks"  element={<AdminWebhooksPage />} />
          <Route path="plans"     element={<AdminPlansPage />} />
          <Route path="add-ons"   element={<AdminAddOnsPage />} />
          <Route path="sync"      element={<AdminSyncPage />} />
          <Route path="email"     element={<AdminEmailPage />} />
          <Route path="reports"   element={<AdminReportsPage />} />
          <Route path="support"   element={<AdminSupportPage />} />
        </Route>
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
